export enum SliderHandleType {
  Circle = 'circle',
  Stick = 'stick'
}
